
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'lovs-management-java-class-input',
    components: {},
    props: {
        selectedJavaClass: { type: Object }
    },
    data() {
        return {
            javaClass: {} as { name: string },
            dirty: false
        }
    },
    watch: {
        selectedJavaClass() {
            this.loadJavaClass()
        }
    },
    created() {
        this.loadJavaClass()
    },
    methods: {
        loadJavaClass() {
            this.javaClass = this.selectedJavaClass as { name: string }
        }
    }
})
